type Size = 'sm' | 'md' | 'lg';

const DIMS: Record<Size, { box: number; font: number }> = {
  sm: { box: 32, font: 13 },
  md: { box: 38, font: 15 },
  lg: { box: 44, font: 18 },
};

export function BrandLockup({ size = 'md' }: { size?: Size }) {
  const d = DIMS[size];
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div
        style={{
          width: d.box,
          height: d.box,
          display: 'grid',
          placeItems: 'center',
          background: 'rgba(102, 224, 255, 0.08)',
          border: '1px solid rgba(102, 224, 255, 0.4)',
          borderRadius: 6,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <img
          src="/logo.webp"
          alt="DenDev"
          style={{
            width: d.box * 0.72,
            height: d.box * 0.72,
            objectFit: 'contain',
            filter: 'brightness(1.1) drop-shadow(0 0 5px rgba(102, 224, 255, 0.45))',
          }}
        />
        <span
          style={{
            position: 'absolute',
            inset: 2,
            border: '1px solid rgba(102, 224, 255, 0.15)',
            borderRadius: 4,
          }}
        />
      </div>
      <div style={{ lineHeight: 1.1 }}>
        <div
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: d.font * 0.95,
            fontWeight: 700,
            color: '#f6fbff',
            letterSpacing: '-0.01em',
          }}
        >
          DenDev Core
        </div>
        <div
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: 9.5,
            color: 'rgba(102, 224, 255, 0.7)',
            textTransform: 'uppercase',
            letterSpacing: '0.2em',
            marginTop: 3,
          }}
        >
          core.dendev.ar · v2.4
        </div>
      </div>
    </div>
  );
}
